<template>
<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" :stroke="secundaryColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.5 33.5V16H31.5V33.5" :stroke="primaryColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 34L34 34" :stroke="primaryColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21.7002 21H22.7002" :stroke="primaryColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M26.2002 21H27.2002" :stroke="primaryColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21.7002 25H22.7002" :stroke="primaryColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M26.2002 25H27.2002" :stroke="primaryColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M22 33.5V29H27V33.5" :stroke="primaryColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 15.5V13H24V15.5" :stroke="primaryColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
    props: {
        primaryColor: {
            type: String,
            default: '#3D5DFC',
            required: false
        },
        secundaryColor: {
            type: String,
            default: '#CAD3FF',
            required: false
        }
    }
}
</script>

<style lang="scss" scoped>

</style>